import { z } from "zod";

export const subscriptionRequestSchema = z.object({
  message: z.string().max(500, "500 caractères maximum").optional(),
  confirmed: z.literal(true, { error: "Vous devez confirmer pour continuer" }),
});

export type SubscriptionRequestFormValues = z.infer<typeof subscriptionRequestSchema>;
